import fetchJSON from '../fetchJSON'
// import { xssSanitize as sanitize } from '@bt-react/libs/sanitize'

// Ensure nothing returned from this is undefined. It MUST be serialisable JSON.

interface Statistics {
  upcomingCommunications?: string
  recordedCommunications?: string
  liveCommunications?: string
  subscribers?: string
  viewedSeconds?: string
}

export type Visibility = 'included' | 'excluded' | 'rule_based'

export interface ChannelResponse {
  id: number,
  statistics?: Statistics
  channelName: string
  channelUrl: string
  channelDescription: string
  strapLine: string
  channelImg?: string,
  locale: string,
  visibility: Visibility
  showAttendees: boolean
  showShare: boolean
  showSocial: boolean
}

export const defaultState: ChannelResponse = {
  id: 0,
  statistics: {},
  channelName: '',
  channelUrl: '',
  channelDescription: '',
  strapLine: '',
  visibility: 'excluded',
  channelImg: '',
  locale: 'en-US',
  showAttendees: false,
  showShare: false,
  showSocial: false
}

function getChannelImg(channelData) {

  if (channelData && channelData.links) {
    const logo = channelData.links.find(({title}) => title === 'logo')
    if (logo) return logo.href
  }

  return defaultState.channelImg

}

export function formatChannelResponse (channelResponse) {

  let showAttendees = defaultState.showAttendees
  let showShare = defaultState.showShare
  let showSocial = defaultState.showSocial
  let locale = defaultState.locale

  for (const feature of channelResponse?.features ?? []) {

    if (feature.name === 'shareEmail') showShare = feature.enabled
    if (feature.name === 'shareSocialise') showSocial = feature.enabled
    if (feature.name === 'attendeeNetworking') showAttendees = feature.enabled
    if (feature?.name === 'locale') locale = feature?.enabled ? (feature?.value || defaultState.locale) : defaultState.locale

  }

  return {
    id: channelResponse?.id ?? defaultState.id,
    statistics: channelResponse?.statistics ?? defaultState.statistics,
    channelName: channelResponse?.title ?? defaultState.channelName,
    // channelName: sanitize(channelResponse?.title ?? defaultState.channelName),
    channelUrl: channelResponse?.url ?? defaultState.channelUrl,
    channelDescription: channelResponse?.description ?? defaultState.channelDescription,
    // channelDescription: sanitize(channelResponse?.description ?? defaultState.channelDescription),
    strapLine: channelResponse?.strapline ?? defaultState.strapLine,
    visibility: channelResponse?.searchVisibility ?? defaultState.visibility,
    channelImg: getChannelImg(channelResponse),
    locale,
    showAttendees,
    showShare,
    showSocial
  }

}

async function fetchChannel (channelId = '', hostUrl = ''): Promise<ChannelResponse> {

  if (!channelId) return formatChannelResponse({})

  const { data } = await fetchJSON('fetchChannel', `${hostUrl || process.env.HOST}/service/channel/v2/channel/${channelId}/public`)

  return formatChannelResponse(data)

}

export default fetchChannel
